import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import EditKpiApi from "../../../api/kpis/EditKpiApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

const { Option } = Select;

function EditKpiModal(props) {
  const [submit, setSubmit] = useState(false);
  const [percentage, setPercentage] = useState(false);
  const [addScaleUnit, setAddScaleUnit] = useState(false);
  const [form] = Form.useForm();
  const [valuesChanged, setValuesChanged] = useState(false);

  function handleCancel() {
    setSubmit(false);
    setPercentage(false);
    setAddScaleUnit(false);
    setValuesChanged(false);
    form.resetFields();
    props.handleCancel();
  }

  useEffect(() => {
    if (props.visible) {
      getScaleUnit();
    }
  }, [props.visible]);

  async function getScaleUnit() {
    if (props.editKpi?.scale?.name === "Number") {
      setAddScaleUnit(false);
      setPercentage(false);
    } else if (props.editKpi?.scale?.name === "Percentage") {
      setAddScaleUnit(false);
      setPercentage(true);
    } else {
      setAddScaleUnit(true);
      setPercentage(false);
    }
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await EditKpiApi(
      props.editKpi.id,
      values.name,
      values.target
    );
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", `KPI edited`);
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add KPI. Try again later."
      );
    }
    handleCancel();
  }

  const unitSelector = (
    <Form.Item name="unitScale" noStyle>
      <Select disabled style={{ width: 100 }}>
        <Option
          key={props.editKpi?.scaleUnitId}
          value={props.editKpi?.scaleUnitId}
        >
          {props.editKpi?.scaleunit?.abbreviation}
        </Option>
      </Select>
    </Form.Item>
  );

  return (
    <>
      <Modal
        title="Edit KPI"
        visible={props.visible}
        onCancel={() => handleCancel()}
        footer={null}
        destroyOnClose={true}
      >
        <Form
          name="editKpi"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          requiredMark={false}
          form={form}
          initialValues={{
            name: props.editKpi?.name,
            targetScale: props.editKpi?.scale?.name,
            target: props.editKpi?.target,
            unitScale: props.editKpi?.scaleUnitId,
          }}
          onValuesChange={() => {
            setValuesChanged(true);
          }}
        >
          <Form.Item label="KPI*" name="name">
            <Input placeholder="KPI" />
          </Form.Item>

          <Form.Item label="Target scale*" name="targetScale">
            <Select disabled showSearch placeholder="Select a scale">
              <Option
                key={props.editKpi?.scale?.name}
                value={props.editKpi?.scale?.name}
              >
                {props.editKpi?.scale?.name}
              </Option>
            </Select>
          </Form.Item>

          <Form.Item label="Target*" name="target">
            <InputNumber
              min={0}
              addonAfter={addScaleUnit ? unitSelector : percentage && "%"}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <div className=" flex justify-end">
              <Button className="mr-3 w-28" onClick={() => handleCancel()}>
                Cancel
              </Button>
              <Button
                className="btn w-28"
                type="primary"
                htmlType={submit && "submit"}
                disabled={submit || !valuesChanged}
              >
                {submit ? (
                  <Spin
                    size="small"
                    indicator={
                      <LoadingOutlined style={{ color: "#fff" }} spin />
                    }
                  />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default EditKpiModal;
